import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';
import DatePicker from '../../../components/DatePicker/index';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';

export class AdditionalItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.howMuchReceivedReimbursement = '';
    item.currentReceivedReimbursement = '';
    item.fromWhomReceivedReimbursement = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
    } = this.props;

    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformationWithIdx} values={{ idx: this.props.index + 1 }} />
            </PageSectionHeader>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.companyNameLoss}
              fieldName={messages.companyNameLoss}
            >
              <Textbox
                disabled={disabled}
                name="companyNameLoss"
                type="text"
                onChange={this.onChange('companyNameLoss')}
                value={item.companyNameLoss}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.companyNameLoss}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
                  name="dateOfLoss"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateOfLoss}
                  fieldName={messages.dateOfLoss}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateOfLoss"
                    type="text"
                    onDayChange={this.handleDayChange('dateOfLoss')}
                    value={item.dateOfLoss}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountPaidLoss}
              fieldName={messages.amountPaidLoss}
            >
              <Textbox
                disabled={disabled}
                name="amountPaidLoss"
                type="number"
                onChange={this.onChange('amountPaidLoss')}
                value={item.amountPaidLoss}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountPaidLoss}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currentAmountPaidLoss}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currentAmountPaidLoss')}
                disabled={disabled}
                value={item.currentAmountPaidLoss}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-7 col-sm-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountOfLoss}
              fieldName={messages.amountOfLoss}
            >
              <Textbox
                disabled={disabled}
                name="amountOfLoss"
                type="number"
                onChange={this.onChange('amountOfLoss')}
                value={item.amountOfLoss}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountOfLoss}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currentAmountOfLoss}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currentAmountOfLoss')}
                disabled={disabled}
                value={item.currentAmountOfLoss}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className={'col-sm-6 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.haveYouReceivedReimbursement} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  type="radio"
                  value="true"
                  checked={item.haveYouReceivedReimbursement === 'true'}
                  onChange={this.onChange('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  type="radio"
                  value="false"
                  checked={item.haveYouReceivedReimbursement === 'false'}
                  onChange={this.onChangeResetReceived('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          <div className={'col-sm-6 form-group'}>
          </div>
        </div>
        {item.haveYouReceivedReimbursement === 'true' && (
          <div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-7 col-sm-7">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.fromWhomReceivedReimbursement}
                  fieldName={messages.fromWhom}
                >
                  <Textbox
                    disabled={disabled}
                    name="fromWhomReceivedReimbursement"
                    type="text"
                    onChange={this.onChange('fromWhomReceivedReimbursement')}
                    value={item.fromWhomReceivedReimbursement}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.fromWhom}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  name="dateReimbursementReceived"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateReimbursementReceived}
                  fieldName={messages.dateReimbursementReceived}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateReimbursementReceived"
                    type="text"
                    onDayChange={this.handleDayChange('dateReimbursementReceived')}
                    value={item.dateReimbursementReceived}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateReimbursementReceived}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateReimbursementReceived}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-7 col-sm-7">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.howMuchReceivedReimbursement}
                  fieldName={messages.howMuchReceivedReimbursement}
                >
                  <Textbox
                    disabled={disabled}
                    name="howMuchReceivedReimbursement"
                    type="number"
                    onChange={this.onChange('howMuchReceivedReimbursement')}
                    value={item.howMuchReceivedReimbursement}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.howMuchReceivedReimbursement}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  className="w-full"
                  defaultValue={item.currentReceivedReimbursement}
                  fieldName={messages.currency}
                >
                  <CurrencySelector
                    onChange={this.handleCurrencyChange('currentReceivedReimbursement')}
                    disabled={disabled}
                    value={item.currentReceivedReimbursement}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.currency}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

AdditionalItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/components/Additional/AdditionalItem.js